import _ from 'lodash'

export const stagesChoices = [
  {
    label: 'Idea',
    value: 'idea',
  },
  {
    label: 'Pre-seed',
    value: 'pre_seed',
  },
  {
    label: 'Seed',
    value: 'seed',
  },
  {
    label: 'Early growth',
    value: 'early_growth',
  },
  {
    label: 'Growth',
    value: 'growth',
  },
  {
    label: 'Maturity',
    value: 'maturity',
  },
]

export function stageLabel(stage) {
  return {
    idea: 'Idea',
    pre_seed: 'Pre-seed',
    seed: 'Seed',
    early_growth: 'Early Growth',
    growth: 'Growth',
    maturity: 'Maturity',
  }[stage]
}

export const stageChoiceByValue = _.keyBy(stagesChoices, 'value')
export const stageChoiceByLabel = _.keyBy(stagesChoices, 'label')
